import {
  DialogContent,
  FormLabel,
  Grid,
  Stack,
  TextField,
} from "@mui/material";
import { useMemo, useState } from "react";
import { CONFIRMATION_MODAL_BUTTONS } from "../../constants";
import { ActionButton } from "../buttons/ActionButton";
import {
  CASH_OUT_ENTER_AMOUNT,
  MANUAL_PAYMENT_REFERENCE_NUMBER,
} from "../constants";
import { IConfirmContractActionProps } from "../models";
import styles from "./styles.module.css";
import { ETrasactionsType } from "../../../../setup/api/services/contract/models";

export const ConfirmContractForm = ({
  contract,
  onConfirm,
  onCancel,
  description,
  withReferenceInput,
}: IConfirmContractActionProps) => {
  const [userInput, setUserInput] = useState<string>();
  const onActionconfirmClick = () => {
    if ((withReferenceInput && userInput) || !withReferenceInput)
      onConfirm(userInput);
  };

  const isCashoutNeeded = useMemo(
    () =>
      contract?.transactions &&
      contract?.transactions?.[0]?.type === ETrasactionsType.CUSTOMER_PAY,
    [contract?.transactions]
  );

  const subTotal = useMemo(() => {
    return (
      (contract?.hasVoucher
        ? contract?.originalItemPrice || contract?.itemPrice
        : contract?.itemPrice) + (contract?.shipment?.fee || 0)
    );
  }, [
    contract?.hasVoucher,
    contract?.itemPrice,
    contract?.originalItemPrice,
    contract?.shipment?.fee,
  ]);

  return (
    <DialogContent>
      <Stack spacing={4} justifyContent="flex-end">
        <Grid>
          <div className={styles.description}>{description}</div>
        </Grid>
        {withReferenceInput && (
          <Stack spacing={1} justifyContent="flex-start" dir="rtl">
            <FormLabel className={styles.additionalReasons}>
              {MANUAL_PAYMENT_REFERENCE_NUMBER}
            </FormLabel>

            <TextField
              placeholder={MANUAL_PAYMENT_REFERENCE_NUMBER}
              onChange={(event) => {
                setUserInput(event.target.value);
              }}
            />
          </Stack>
        )}
        <Grid
          container
          spacing={2}
          columns={16}
          direction={{ xs: "column", sm: "row" }}>
          <Grid item xs={8}>
            <ActionButton
              onClick={onCancel}
              title={CONFIRMATION_MODAL_BUTTONS.CANCEL}
              backgroundColor="#F3F4F5"
              color="#404D58"
            />
          </Grid>
          <Grid item xs={8}>
            <ActionButton
              onClick={onActionconfirmClick}
              disabled={!userInput && withReferenceInput}
              title={CONFIRMATION_MODAL_BUTTONS.CONFIRM}
              backgroundColor="rgba(68, 193, 110, 0.07)"
              color="rgba(68, 193, 110)"
            />
          </Grid>
        </Grid>
      </Stack>
    </DialogContent>
  );
};
